export const companyNavigation = [
  {label: 'About Us', href: '/about-us'},
  {label: 'Contact Us', href: '/contact-us'},
  {label: 'Advertise With Us', href: '/advertise-with-us'},
  {label: 'Privacy Policy', href: '/privacy-policy'},
  {label: 'Terms of Use', href: '/terms-of-use'},
];
